import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

import Footer from "../../components/Footer";
import DFNavbar from "../../components/Navbar";
import dfviewer_icon from "./../../img/dfviewer/icon.jpg";
import dfviewer_screen from "./../../img/dfviewer/screen.png";
import dfviewer_data_visualization from "./../../img/dfviewer/data-visualization.png";
import dfviewer_data_visualization2 from "./../../img/dfviewer/data-visualization2.png";
import dfviewer_statistical_info from "./../../img/dfviewer/statistical-info.png";
import { ScrollToTop } from "../../components/ScrollToTop";
import { DOWNLOAD_ROUTE } from "../../consts/routes";
import { Helmet } from "react-helmet";
import i18n from "../../i18n/configs";

/**
 * DF Viewer詳細画面
 * @returns JSX.Element
 */
const DetailDfviewer = () => {
    const { t } = useTranslation();

    return (
        <div className="flex min-h-screen flex-col">
            <Helmet>
                <title>{t("DetailDfviewer.meta.title")}</title>
                <meta name="description" content={t("DetailDfviewer.meta.description")} />
            </Helmet>
            <ScrollToTop />
            <DFNavbar bottomPadding={true} />
            <div className="flex-grow items-center justify-center px-6 py-8 pt-20 lg:px-20">
                <div className="mx-auto max-w-screen-md px-4 md:px-8">
                    <div className="flex items-center justify-center">
                        <img className="h-20 w-20 p-3" src={dfviewer_icon} alt="dflat" />
                        <h1 className="text-center text-2xl font-bold text-gray-800 sm:text-3xl ">DF Viewer</h1>
                    </div>
                </div>

                <div className="mx-auto mt-10 flex max-w-3xl items-center justify-center">
                    {i18n.language === "ja"
                        ? "「DF Viewer」詳細ページは移行しました。"
                        : "The 'DF Viewer' details page has been moved."}
                </div>
                <div className="mx-auto flex max-w-3xl items-center justify-center">
                    <a
                        href={
                            i18n.language === "ja"
                                ? "https://deepforest-tech.co.jp/df-viewer/"
                                : "https://deepforest-tech.co.jp/en/df-viewer/"
                        }
                        className="link-text mt-4 text-sm font-bold"
                    >
                        {i18n.language === "ja" ? "新しいページへ移動する" : "Go to the new page."}
                    </a>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default DetailDfviewer;
